// discovery で write/notify 両持ちの characteristic が見つからない場合に送出。
export class BleCharacteristicCapabilityException extends Error {
  readonly serviceUuid: string
  constructor(serviceUuid: string, message?: string) {
    super(
      message ??
        `required write/notify characteristic not found (service=${serviceUuid})`
    )
    this.name = 'BleCharacteristicCapabilityException'
    this.serviceUuid = serviceUuid
    Object.setPrototypeOf(this, BleCharacteristicCapabilityException.prototype)
  }
}
